<div class="comp-container">
<div class="border-box">
    <div >Upload files</div>
  <div class=" m-5 row justify-content-center">
        
  <form enctype="multipart/form-data" method="post" (submit)="uploadFile()" class="p-4" style="width: 600px; height: 500px;">
    <mat-card style="height: 100%; " class="bg-light">
      <mat-card-content>
        <div class="mb-3">
          <mat-label class="form-label fw-bold mb-2 mb-3">Document Type <span class="text-danger">*</span></mat-label>
          <select class="form-control" [(ngModel)]="selectedDocumentType" name="selectedDocumentType" required #docType="ngModel">
            <option value="" disabled selected>Select document type</option>
            <option *ngFor="let type of documentTypes" [value]="type">{{ type }}</option>
          </select>
          <div *ngIf="(docType.touched || isDocTypeMissing) && (selectedDocumentType == null || selectedDocumentType === '')" class="text-danger mt-2">
            Document type is required.
          </div>

        </div>
        <div class="p-3 rounded ">
          <mat-label class="form-label fw-bold mb-2">Select files to upload <span class="text-danger">*</span></mat-label>
          <input id="file-upload"  name="fileUpload"  type="file" multiple aria-label="Select" class="form-control mt-1 w-100" (change)="onFileSelected($event)" required />
          <span *ngIf="uploadedFiles.length>0" class="d-block mt-2 text-secondary">File size: {{fileSize}}</span>
          <div *ngIf=" isFileMissing &&  uploadedFiles.length === 0" class="text-danger mt-2">
            Please select at least one file to upload.
          </div>
        </div>
        <div class="mt-4 mb-2 d-flex justify-content-between align-items-center gap-5 grid-column-gap-15">
            <button mat-raised-button color="primary" type="submit" class="w-50 main-background-color">Upload</button>
          <button mat-raised-button color="primary" type="reset" class="w-50 main-background-color"  (click)="reset()">Reset</button>
        </div>
        <div class="bottom-banner mt-3 p-3 rounded bg-white" *ngIf="canUpload">
          <div class="text-center mb-2">
            <span class="fw-bold text-success">{{percentage}}% Uploaded...</span>
            <span *ngIf="timeTaken" class="text-muted"> in {{timeTaken}}</span>
          </div>
          <mat-progress-bar color="primary" [mode]="progressBarMode" [value]="percentage"></mat-progress-bar>
        </div>
      </mat-card-content>
    </mat-card>
  </form>
  
  </div>
</div>
</div>